module.exports = __webpack_public_path__ + "static/media/iconwallpaper.c2a46339.png";